// Multi-language support for TREBOL FINANCE
const translations = {
  es: {
    // Navigation
    dashboard: "Panel de Control",
    transactions: "Transacciones",
    categories: "Categorías",
    accounts: "Cuentas",
    reports: "Informes",
    calculators: "Calculadoras",
    assistant: "Asistente",
    settings: "Configuración",
    logout: "Cerrar Sesión",
    
    // Auth
    login: "Iniciar Sesión",
    register: "Registrarse",
    email: "Correo Electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    name: "Nombre",
    forgotPassword: "¿Olvidaste tu contraseña?",
    noAccount: "¿No tienes cuenta?",
    hasAccount: "¿Ya tienes cuenta?",
    
    // Dashboard
    totalBalance: "Balance Total",
    monthlyIncome: "Ingresos del Mes",
    monthlyExpenses: "Gastos del Mes",
    monthlySavings: "Ahorro del Mes",
    dailyAverage: "Promedio Diario",
    topCategory: "Mayor Categoría",
    lastTransaction: "Última Transacción",
    financialTip: "Consejo Financiero",
    incomeVsExpenses: "Ingresos vs Gastos",
    expensesByCategory: "Gastos por Categoría",
    accountsSummary: "Resumen de Cuentas",
    
    // Transactions
    newTransaction: "Nueva Transacción",
    editTransaction: "Editar Transacción",
    income: "Ingreso",
    expense: "Gasto",
    transfer: "Transferencia",
    amount: "Monto",
    category: "Categoría",
    account: "Cuenta",
    date: "Fecha",
    description: "Descripción",
    notes: "Notas",
    recurring: "Recurrente",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    filter: "Filtrar",
    search: "Buscar",
    all: "Todos",
    
    // Categories
    newCategory: "Nueva Categoría",
    editCategory: "Editar Categoría",
    categoryName: "Nombre de Categoría",
    icon: "Icono",
    color: "Color",
    
    // Accounts
    newAccount: "Nueva Cuenta",
    editAccount: "Editar Cuenta",
    accountName: "Nombre de Cuenta",
    accountType: "Tipo de Cuenta",
    balance: "Saldo",
    bank: "Banco",
    cash: "Efectivo",
    creditCard: "Tarjeta de Crédito",
    investment: "Inversión",
    
    // Reports
    monthlyReport: "Informe Mensual",
    annualReport: "Informe Anual",
    generateReport: "Generar Informe",
    startDate: "Fecha Inicio",
    endDate: "Fecha Fin",
    totalIncome: "Total Ingresos",
    totalExpenses: "Total Gastos",
    netSavings: "Ahorro Neto",
    savingsRate: "Tasa de Ahorro",
    
    // Calculators
    savingsCalculator: "Calculadora de Ahorro",
    investmentCalculator: "Calculadora de Inversión",
    expenseImpact: "Impacto de Gastos",
    monthlySavingsAmount: "Ahorro Mensual",
    months: "Meses",
    years: "Años",
    interestRate: "Tasa de Interés",
    calculate: "Calcular",
    result: "Resultado",
    projectedValue: "Valor Proyectado",
    totalContributed: "Total Aportado",
    interestEarned: "Intereses Ganados",
    
    // Assistant
    askAssistant: "Pregunta al asistente...",
    suggestions: "Sugerencias",
    
    // Settings
    profile: "Perfil",
    language: "Idioma",
    currency: "Moneda",
    theme: "Tema",
    light: "Claro",
    dark: "Oscuro",
    
    // Messages
    welcome: "Bienvenido a TREBOL FINANCE",
    tagline: "Control total de tus finanzas personales",
    loginSuccess: "Sesión iniciada correctamente",
    registerSuccess: "Cuenta creada correctamente",
    transactionCreated: "Transacción registrada",
    transactionUpdated: "Transacción actualizada",
    transactionDeleted: "Transacción eliminada",
    categoryCreated: "Categoría creada",
    categoryUpdated: "Categoría actualizada",
    categoryDeleted: "Categoría eliminada",
    accountCreated: "Cuenta creada",
    accountUpdated: "Cuenta actualizada",
    accountDeleted: "Cuenta eliminada",
    error: "Error",
    success: "Éxito",
    loading: "Cargando...",
  },
  en: {
    dashboard: "Dashboard",
    transactions: "Transactions",
    categories: "Categories",
    accounts: "Accounts",
    reports: "Reports",
    calculators: "Calculators",
    assistant: "Assistant",
    settings: "Settings",
    logout: "Logout",
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    name: "Name",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    totalBalance: "Total Balance",
    monthlyIncome: "Monthly Income",
    monthlyExpenses: "Monthly Expenses",
    monthlySavings: "Monthly Savings",
    dailyAverage: "Daily Average",
    topCategory: "Top Category",
    lastTransaction: "Last Transaction",
    financialTip: "Financial Tip",
    incomeVsExpenses: "Income vs Expenses",
    expensesByCategory: "Expenses by Category",
    accountsSummary: "Accounts Summary",
    newTransaction: "New Transaction",
    editTransaction: "Edit Transaction",
    income: "Income",
    expense: "Expense",
    transfer: "Transfer",
    amount: "Amount",
    category: "Category",
    account: "Account",
    date: "Date",
    description: "Description",
    notes: "Notes",
    recurring: "Recurring",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    filter: "Filter",
    search: "Search",
    all: "All",
    newCategory: "New Category",
    editCategory: "Edit Category",
    categoryName: "Category Name",
    icon: "Icon",
    color: "Color",
    newAccount: "New Account",
    editAccount: "Edit Account",
    accountName: "Account Name",
    accountType: "Account Type",
    balance: "Balance",
    bank: "Bank",
    cash: "Cash",
    creditCard: "Credit Card",
    investment: "Investment",
    monthlyReport: "Monthly Report",
    annualReport: "Annual Report",
    generateReport: "Generate Report",
    startDate: "Start Date",
    endDate: "End Date",
    totalIncome: "Total Income",
    totalExpenses: "Total Expenses",
    netSavings: "Net Savings",
    savingsRate: "Savings Rate",
    savingsCalculator: "Savings Calculator",
    investmentCalculator: "Investment Calculator",
    expenseImpact: "Expense Impact",
    monthlySavingsAmount: "Monthly Savings",
    months: "Months",
    years: "Years",
    interestRate: "Interest Rate",
    calculate: "Calculate",
    result: "Result",
    projectedValue: "Projected Value",
    totalContributed: "Total Contributed",
    interestEarned: "Interest Earned",
    askAssistant: "Ask the assistant...",
    suggestions: "Suggestions",
    profile: "Profile",
    language: "Language",
    currency: "Currency",
    theme: "Theme",
    light: "Light",
    dark: "Dark",
    welcome: "Welcome to TREBOL FINANCE",
    tagline: "Total control of your personal finances",
    loginSuccess: "Logged in successfully",
    registerSuccess: "Account created successfully",
    transactionCreated: "Transaction recorded",
    transactionUpdated: "Transaction updated",
    transactionDeleted: "Transaction deleted",
    categoryCreated: "Category created",
    categoryUpdated: "Category updated",
    categoryDeleted: "Category deleted",
    accountCreated: "Account created",
    accountUpdated: "Account updated",
    accountDeleted: "Account deleted",
    error: "Error",
    success: "Success",
    loading: "Loading...",
  },
  fr: {
    dashboard: "Tableau de Bord",
    transactions: "Transactions",
    categories: "Catégories",
    accounts: "Comptes",
    reports: "Rapports",
    calculators: "Calculatrices",
    assistant: "Assistant",
    settings: "Paramètres",
    logout: "Déconnexion",
    login: "Connexion",
    register: "S'inscrire",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    totalBalance: "Solde Total",
    monthlyIncome: "Revenus Mensuels",
    monthlyExpenses: "Dépenses Mensuelles",
    monthlySavings: "Épargne Mensuelle",
    newTransaction: "Nouvelle Transaction",
    income: "Revenu",
    expense: "Dépense",
    amount: "Montant",
    category: "Catégorie",
    account: "Compte",
    date: "Date",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    welcome: "Bienvenue sur TREBOL FINANCE",
    tagline: "Contrôle total de vos finances personnelles",
    loading: "Chargement...",
  },
  ca: {
    dashboard: "Tauler de Control",
    transactions: "Transaccions",
    categories: "Categories",
    accounts: "Comptes",
    reports: "Informes",
    calculators: "Calculadores",
    assistant: "Assistent",
    settings: "Configuració",
    logout: "Tancar Sessió",
    login: "Iniciar Sessió",
    register: "Registrar-se",
    email: "Correu Electrònic",
    password: "Contrasenya",
    name: "Nom",
    totalBalance: "Balanç Total",
    monthlyIncome: "Ingressos del Mes",
    monthlyExpenses: "Despeses del Mes",
    monthlySavings: "Estalvi del Mes",
    newTransaction: "Nova Transacció",
    income: "Ingrés",
    expense: "Despesa",
    amount: "Import",
    category: "Categoria",
    account: "Compte",
    date: "Data",
    save: "Desar",
    cancel: "Cancel·lar",
    delete: "Eliminar",
    welcome: "Benvingut a TREBOL FINANCE",
    tagline: "Control total de les teves finances personals",
    loading: "Carregant...",
  },
  de: {
    dashboard: "Dashboard",
    transactions: "Transaktionen",
    categories: "Kategorien",
    accounts: "Konten",
    reports: "Berichte",
    calculators: "Rechner",
    assistant: "Assistent",
    settings: "Einstellungen",
    logout: "Abmelden",
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    totalBalance: "Gesamtsaldo",
    monthlyIncome: "Monatliches Einkommen",
    monthlyExpenses: "Monatliche Ausgaben",
    monthlySavings: "Monatliche Ersparnisse",
    newTransaction: "Neue Transaktion",
    income: "Einkommen",
    expense: "Ausgabe",
    amount: "Betrag",
    category: "Kategorie",
    account: "Konto",
    date: "Datum",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    welcome: "Willkommen bei TREBOL FINANCE",
    tagline: "Volle Kontrolle über Ihre persönlichen Finanzen",
    loading: "Wird geladen...",
  },
  it: {
    dashboard: "Pannello di Controllo",
    transactions: "Transazioni",
    categories: "Categorie",
    accounts: "Conti",
    reports: "Rapporti",
    calculators: "Calcolatrici",
    assistant: "Assistente",
    settings: "Impostazioni",
    logout: "Disconnetti",
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    name: "Nome",
    totalBalance: "Saldo Totale",
    monthlyIncome: "Entrate Mensili",
    monthlyExpenses: "Spese Mensili",
    monthlySavings: "Risparmio Mensile",
    newTransaction: "Nuova Transazione",
    income: "Entrata",
    expense: "Spesa",
    amount: "Importo",
    category: "Categoria",
    account: "Conto",
    date: "Data",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    welcome: "Benvenuto su TREBOL FINANCE",
    tagline: "Controllo totale delle tue finanze personali",
    loading: "Caricamento...",
  }
};

export const getTranslation = (lang, key) => {
  const langTranslations = translations[lang] || translations.es;
  return langTranslations[key] || translations.es[key] || key;
};

export const useTranslation = (lang = 'es') => {
  return (key) => getTranslation(lang, key);
};

export const languages = [
  { code: 'es', name: 'Español' },
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
  { code: 'ca', name: 'Català' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
];

export default translations;
